// HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method
const assignedElements_ = HTMLSlotElement.prototype.assignedElements; // HACK: @lwc/synthetic-shadow overrides slot.assignedElements()

function assignedElements(node, options) {
  return assignedElements_.call(node, options);
} // HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method

const assignedNodes_ = HTMLSlotElement.prototype.assignedNodes; // HACK: @lwc/synthetic-shadow overrides slot.assignedNodes()

function assignedNodes(node, options) {
  return assignedNodes_.call(node, options);
} // HACK: This needs to run BEFORE @lwc/synthetic-shadow is loaded
// eslint-disable-next-line @typescript-eslint/unbound-method

const children_ = Object.getOwnPropertyDescriptor(
  Element.prototype,
  "children"
); // HACK: @lwc/synthetic-shadow overrides element.children

function children(node) {
  return Array.from(children_.get.call(node));
}
function assignedSlotNames(template) {
  let slots = Array.from(template.querySelectorAll("slot"));
  return slots
    .filter(isSlotAssigned)
    .map((slot) => slot.getAttribute("name") || "default");
}
function isSlotAssigned(slot) {
  let [element] = assignedElements(slot);

  if (element) {
    if (element.tagName === "SLOT") {
      return isSlotAssigned(element);
    }

    return true;
  }

  return children(slot).length > 0;
}

export {
  assignedElements,
  assignedNodes,
  assignedSlotNames,
  children,
  isSlotAssigned,
};
